export enum NotiActionType {
	URL = 'URL',
	HURL = 'HURL',
	NTAB = 'NTAB',
}
